'use es6';

const getVersionAsSymbol = version => {
  return version < 36 ? version.toString(36) : (version - 26).toString(36).toUpperCase();
};
export default getVersionAsSymbol;